import { IconProps, Icon } from "@chakra-ui/icon";

const LabelsIcon = (props: IconProps) => {
	return (
		<Icon
			viewBox="0 0 24 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				opacity="0.12"
				d="M3.93726 13.4373C3.59136 13.0914 3.4184 12.9184 3.29472 12.7166C3.18506 12.5376 3.10425 12.3425 3.05526 12.1385C3 11.9083 3 11.6637 3 11.1745L3 9.2C3 8.07989 3 7.51984 3.21799 7.09202C3.40973 6.71569 3.7157 6.40973 4.09202 6.21799C4.51984 6 5.0799 6 6.2 6H9.17452C9.6637 6 9.90829 6 10.1385 6.05526C10.3425 6.10425 10.5376 6.18506 10.7166 6.29472C10.9184 6.4184 11.0914 6.59135 11.4373 6.93726L18.7373 14.2373C19.5293 15.0293 19.9253 15.4253 20.0737 15.882C20.2042 16.2837 20.2042 16.7163 20.0737 17.118C19.9253 17.5747 19.5293 17.9707 18.7373 18.7627L16.2627 21.2373C15.4707 22.0293 15.0747 22.4253 14.618 22.5737C14.2163 22.7042 13.7837 22.7042 13.382 22.5737C12.9253 22.4253 12.5293 22.0293 11.7373 21.2373L3.93726 13.4373Z"
				fill="currentColor"
			/>
			<path
				d="M21 11.5L13.4059 3.90589C12.887 3.38703 12.6276 3.1276 12.3249 2.94208C12.0564 2.77759 11.7638 2.65638 11.4577 2.58289C11.1124 2.5 10.7455 2.5 10.0118 2.5L6 2.5M3 9.2L3 11.1745C3 11.6637 3 11.9083 3.05526 12.1385C3.10425 12.3425 3.18506 12.5376 3.29472 12.7166C3.4184 12.9184 3.59136 13.0914 3.93726 13.4373L11.7373 21.2373C12.5293 22.0293 12.9253 22.4253 13.382 22.5737C13.7837 22.7042 14.2163 22.7042 14.618 22.5737C15.0747 22.4253 15.4707 22.0293 16.2627 21.2373L18.7373 18.7627C19.5293 17.9707 19.9253 17.5747 20.0737 17.118C20.2042 16.7163 20.2042 16.2837 20.0737 15.882C19.9253 15.4253 19.5293 15.0293 18.7373 14.2373L11.4373 6.93726C11.0914 6.59136 10.9184 6.4184 10.7166 6.29472C10.5376 6.18506 10.3425 6.10425 10.1385 6.05526C9.90829 6 9.6637 6 9.17452 6H6.2C5.0799 6 4.51984 6 4.09202 6.21799C3.7157 6.40973 3.40973 6.71569 3.21799 7.09202C3 7.51984 3 8.07989 3 9.2Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
};

export default LabelsIcon;
